// the navigo library blocks click event handler on data-navigo anchor items

import { HSDropdown } from "preline";

// so the dropdowns don't close when clicked on them
export function closeDDOnNavigoClick() {
  const navigoLinks = document.querySelectorAll("[data-navigo]");
  navigoLinks.forEach((link) => {
    link.addEventListener("click", function () {
      const allDropdownElems = document.querySelectorAll(
        ".hs-dropdown"
      ) as NodeListOf<HTMLElement>;
      allDropdownElems.forEach((ddElem) => HSDropdown.close(ddElem));
    });
  });
}
